




















































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeAgendamentoStore from '@/components/Backoffice/Store/BackofficeAgendamentoStore'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import HistoricoSolicitacaoStore from '@/components/HistoricoSolicitacao/Store/HistoricoSolicitacaoStore'
import ReservaSalaStore from '@/components/ReservaSala/Store/ReservaSalaStore'
import { TipoUsuarioEnum, CancelarSolicitacaoParam, TipoOrigemEnum, RequestMessage, TipoMensagemEnum } from '@/types/_'
import { timeoutDefault, groupCollectionByField, maskHour } from '@/utils/common'
import { Triagem, ITriagem } from '@/types/implements/Triagem'
import EventBus from '@/plugins/EventBus'
import { permissionService } from '@/services/permission.service'
import SolicitacaoCirurgiaApi from '@/Apis/Agendamento/Services/SolicitacaoCirurgiaApi'
import BackofficeRegulacaoStore from './Store/BackofficeRegulacaoStore'
import BackofficeAutorizacaoStore from './Store/BackofficeAutorizacaoStore'

enum AuthorizeStatusEnum {
  autorizadaPelaRegulacao = 'AutorizadaPelaRegulacao',
  autorizadaParcialPelaRegulacao = 'AutorizadaParcialPelaRegulacao',
  autorizacaoNegadaPelaRegulacao = 'AutorizacaoNegadaPelaRegulacao',
}

@Component
export default class ComponentModalRegulacao extends Vue {
  $refs: {
    refConfirmarTriagem: any,
    modalContainer: HTMLElement
  }

  tipoAutorizacaoAnexo: any = {
    pedidoMedico: true,
    laudo: true,
    cotacaoOpme: true,
    laudoAnestesista: false,
    anexoOperadora: false,
    resumo: true,
  }

  tipoUsuario: TipoUsuarioEnum = TipoUsuarioEnum.Hospital

  step: number = 1
  loadHistorico: boolean = false
  loadNextStep: boolean = false
  loadCancelamento: boolean = false
  loadClose: boolean = false
  loadMensagem: boolean = false
  loadUpload: boolean = false
  loadClosePedencia: boolean = false
  loadConfirmar: boolean = false
  loadCloseBnt: boolean = false
  disableConfirmarTriagem: boolean = true

  triagem: ITriagem = new Triagem()

  mensagem: string = ''
  inputFiles: any[] = []
  reasonForSendToFidelization: string
  showSuggestionModal: boolean = false

  showSendToFidelizationModal: boolean = false
  loadingSendToFidelization: boolean = false

  authorizeStatusEnum = AuthorizeStatusEnum // Create a enum ref

  showAuthorizeModal: boolean = false
  loadingAuthorize: boolean = false
  authorizationStatus: AuthorizeStatusEnum | null = null
  authorizationNotes = ''

  showModalCategoriaDoPlanoParaFidelizacao = false
  loadingUpdateCategoriaDoPlanoParaFidelizacao = false

  get categoriaDoPlanoParaFidelizacao() {
    return this.getBackofficeGlobalStore.solicitacao.categoriaDoPlanoParaFidelizacao!
  }

  set categoriaDoPlanoParaFidelizacao(value: string) {
    this.getBackofficeGlobalStore.solicitacao.categoriaDoPlanoParaFidelizacao = value
  }

  get getDisableConfirmarTriagem() {
    return this.disableConfirmarTriagem
  }

  set getDisableConfirmarTriagem(value: boolean) {
    this.disableConfirmarTriagem = value
  }

  get loadingCloseBtn() {
    return this.loadCloseBnt
  }

  set loadingCloseBtn(val: boolean) {
    this.loadCloseBnt = val
  }

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(val: boolean) {
    this.loadConfirmar = val
  }

  get loadingUpload() {
    return this.loadUpload
  }

  set loadingUpload(val: boolean) {
    this.loadUpload = val
  }

  get loadingMensagem() {
    return this.loadMensagem
  }

  set loadingMensagem(val: boolean) {
    this.loadMensagem = val
  }

  get getMensagem() {
    return this.mensagem
  }

  set getMensagem(texto: string) {
    this.mensagem = texto
  }

  get getStep() {
    return this.step
  }

  set getStep(value: number) {
    this.step = value
  }

  get loadingClose() {
    return this.loadClose
  }

  set loadingClose(value: boolean) {
    this.loadClose = value
  }

  get loadingCancelamento() {
    return this.loadCancelamento
  }

  set loadingCancelamento(value: boolean) {
    this.loadCancelamento = value
  }

  get loadingNextStep() {
    return this.loadNextStep
  }

  set loadingNextStep(value: boolean) {
    this.loadNextStep = value
  }

  get loadingHistorico() {
    return this.loadHistorico
  }

  set loadingHistorico(value: boolean) {
    this.loadHistorico = value
  }

  get getHistoricoSolicitacaoStore() {
    return getModule(HistoricoSolicitacaoStore, this.$store)
  }

  get surgerySolicitationStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get bakofficeAutorizacaoStore() {
    return getModule(BackofficeAutorizacaoStore, this.$store)
  }

  get backofficeRegulacaoStore() {
    return getModule(BackofficeRegulacaoStore, this.$store)
  }

  get getBackofficeAgendamentoStore() {
    return getModule(BackofficeAgendamentoStore, this.$store)
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get getReservaSalaStore() {
    return getModule(ReservaSalaStore, this.$store)
  }

  get getTipoConfirmacao() {
    return TipoOrigemEnum.Triagem
  }

  get getRequestMessage() {
    return new RequestMessage()
  }

  get showModalRegulacao() {
    const show = this.getBackofficeGlobalStore.modal.regulacao
    this.toggleHtmlOverflow(show)
    this.scrollToMensagem()

    return show
  }

  get getTipoMensagemEnum() {
    return TipoMensagemEnum
  }

  get getPedidoMedico() {
    const anexos: any[] = []
    if (this.getBackofficeGlobalStore.solicitacao.url) {
      anexos.push({ url: this.getBackofficeGlobalStore.solicitacao.url, nomeOriginalArquivo: 'Pedido médico' })
    }
    return anexos
  }

  @Watch('showModalRegulacao')
  showModalRegulacaoChange(showModalFidelizacao: boolean) {
    if (
      showModalFidelizacao
      && this.canShowCategoriaDoPlanoParaFidelizacao
      && this.getBackofficeGlobalStore.solicitacao.categoriaDoPlanoParaFidelizacao === 'indefinido'
    ) {
      this.showModalCategoriaDoPlanoParaFidelizacao = true
    } else {
      this.showModalCategoriaDoPlanoParaFidelizacao = false
    }
  }

  async updateCategoriaDoPlanoParaFidelizacao(categoria: string) {
    this.loadingUpdateCategoriaDoPlanoParaFidelizacao = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    const categoriaDoPlanoParaFidelizacao = categoria || this.categoriaDoPlanoParaFidelizacao!

    try {
      const res = await SolicitacaoCirurgiaApi.updateCategoriaDoPlanoParaFidelizacao(solicitacaoId, categoriaDoPlanoParaFidelizacao)

      if (res.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Categoria salva com sucesso!', icon: 'done', color: '#2E7D32' })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao alterar a categoria!', icon: 'warning', color: '#C62828' })
      }

      this.showModalCategoriaDoPlanoParaFidelizacao = false
    } finally {
      this.loadingUpdateCategoriaDoPlanoParaFidelizacao = false
    }
  }

  groupByDate(value: any) {
    return groupCollectionByField(value)
  }

  formatHour(value: string) {
    return maskHour(value)
  }

  async nextStep(step) {
    this.loadingNextStep = true
    await timeoutDefault()

    this.getStep = step

    this.loadingNextStep = false
    return true
  }

  setStep(step) {
    this.getStep = step
  }

  async showModalCancelamento() {
    this.loadingCancelamento = true
    await timeoutDefault()
    const cancelarSolicitacaoParam: CancelarSolicitacaoParam = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      tipoOrigem: TipoOrigemEnum.Agendamento,
      situacao: this.getBackofficeGlobalStore.solicitacao.situacao,
      canceladoMotivo: {
        display: '',
        key: '',
      },
      modal: 'triagem',
    }

    if (this.getBackofficeGlobalStore.solicitacao.canceladoMotivo) {
      cancelarSolicitacaoParam.canceladoMotivo = this.getBackofficeGlobalStore.solicitacao.canceladoMotivo
    }

    this.getSolicitacaoCancelamentoStore.setCancelarSolicitacaoParam(cancelarSolicitacaoParam)
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoTriagem(true)
    await this.getSolicitacaoCancelamentoStore.getMotivosCancelamentoAll({ hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId })
    this.loadingCancelamento = false
  }

  async showHistory() {
    this.loadingHistorico = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.getHistoricoSolicitacaoStore.getHistoricoSolicitacao(solicitacaoId)
    this.loadingHistorico = false
  }

  async sendToFidelization() {
    try {
      this.loadingSendToFidelization = true

      if (!this.reasonForSendToFidelization) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Por favor, informe a razão de encaminhar para Fidelização', icon: 'warning', color: '#C62828' })
      } else {
        const surgerySolicitationId = this.getBackofficeGlobalStore.solicitacao.id

        const res = await this.backofficeRegulacaoStore.sendToFidelization({
          surgerySolicitationId,
          reason: this.reasonForSendToFidelization,
        })

        if (res.success) {
          this.step = 1

          EventBus.$emit('setSnackbar', { show: true, text: 'Encaminhado para fidelização com sucesso!', icon: 'done', color: '#2E7D32' })

          await this.closeModal()
        } else {
          EventBus.$emit('setSnackbar', { show: true, text: res.message || 'Erro ao encaminhar para fidelização', icon: 'warning', color: '#C62828' })
        }
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao encaminhar para fidelização', icon: 'warning', color: '#C62828' })
    } finally {
      this.loadingSendToFidelization = false
    }
  }

  async authorize() {
    try {
      this.loadingAuthorize = true

      const surgerySolicitationId = this.getBackofficeGlobalStore.solicitacao.id

      const res = await this.backofficeRegulacaoStore.regulacaoFazAnalise({
        surgerySolicitationId,
        reason: this.authorizationNotes,
        statusFidelizacao: this.authorizationStatus,
      })

      if (res.success) {
        this.step = 1

        EventBus.$emit('setSnackbar', { show: true, text: 'Análise finalizada com sucesso!', icon: 'done', color: '#2E7D32' })

        await this.closeModal()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: res.message || 'Erro ao finalizar análise', icon: 'warning', color: '#C62828' })
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao finalizar análise', icon: 'warning', color: '#C62828' })
    } finally {
      this.loadingAuthorize = false
    }
  }

  async backStep(step) {
    this.loadingCloseBtn = true
    await timeoutDefault()

    this.getReservaSalaStore.clearReservaSalasResource()
    this.getReservaSalaStore.clearReservaSalaEvent()
    this.getReservaSalaStore.clearPrecaucoesFromTasy()
    this.getStep = step
    this.loadingCloseBtn = false
  }

  toggleHtmlOverflow(isOpen: Boolean) {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'

    if (html !== null) {
      html.classList.remove(noOverflowClass)
      if (isOpen) {
        html.classList.toggle(noOverflowClass)
        const doc = document.getElementsByClassName('v-dialog')[0]
        if (doc) {
          doc.scrollTop = 0
        }
      }
    }
  }

  scrollToMensagem() {
    const ele = document.getElementsByClassName('scroll_top_triagem')
    if (ele.length > 0) {
      ele[0].scrollTo(0, 0)
    }
  }

  async closeModalCancelamento() {
    this.getBackofficeAgendamentoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
    await this.closeModal()
  }

  async closeModal() {
    await this.backofficeRegulacaoStore.unblockFidelizationSurgerySolicitation(this.getBackofficeGlobalStore.solicitacao.id)

    this.setStep(1)

    this.loadingClose = true
    this.reasonForSendToFidelization = ''
    this.showAuthorizeModal = false
    this.loadingAuthorize = false
    this.authorizationStatus = null
    this.authorizationNotes = ''

    await this.getBackofficeGlobalStore.closeModalRegulacao()

    await this.bakofficeAutorizacaoStore.loadAgendamentosMedicoSearch()

    this.loadingClose = false
  }

  sendToFidelizationModal() {
    this.showSendToFidelizationModal = true
  }

  authorizeModal() {
    this.showAuthorizeModal = true
    this.authorizationStatus = AuthorizeStatusEnum.autorizadaPelaRegulacao
  }

  authorizePartiallyModal() {
    this.showAuthorizeModal = true
    this.authorizationStatus = AuthorizeStatusEnum.autorizadaParcialPelaRegulacao
  }

  denyAuthorizationModal() {
    this.showAuthorizeModal = true
    this.authorizationStatus = AuthorizeStatusEnum.autorizacaoNegadaPelaRegulacao
  }

  load: boolean = false
  status: string = ''

  get loading() {
    return this.load
  }

  set loading(value: boolean) {
    this.load = value
  }

  get canShowSendToFidelizationBtn() {
    return permissionService.hasPermission('agendamento.backoffice.regulacao.encaminharParaFidelizacao')
  }

  get canShowAuthorizeBtn() {
    return permissionService.hasPermission('agendamento.backoffice.regulacao.finalizaAnalise')
  }

  get canShowAuthorizePartiallyBtn() {
    return permissionService.hasPermission('agendamento.backoffice.regulacao.finalizaAnalise')
  }

  get canShowDenyAuthorizationBtn() {
    return permissionService.hasPermission('agendamento.backoffice.regulacao.finalizaAnalise')
  }

  get canShowCategoriaDoPlanoParaFidelizacao() {
    return permissionService.hasPermission('agendamento.backoffice.protocolo.visualizarProductLine')
  }

  windowWidth: number = 0
  getWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })

    EventBus.$on('disabledConfirmarTriagem', (value) => { this.getDisableConfirmarTriagem = value })
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }
}
